// extracted by mini-css-extract-plugin
module.exports = {"main":"GameScreens_main__2hKTf","slider":"GameScreens_slider__zdWCZ"};